import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Modal from '@atlaskit/modal-dialog';

const ErrorModal = ({ onClose }) => (
  <Modal
    appearance="danger"
    heading="No users found"
    onClose={onClose}
    width="small"
    actions={[{
      appearance: 'subtle',
      onClick: onClose,
      text: 'Cancel',
    }]}
  >
    <div style={{ paddingLeft: 34 }}>
      <p>Please enter a correct user.</p>
      <p>
        If you typed the URL with your hand,
        please use the list page and the buttons.
      </p>
    </div>
  </Modal>
);

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ErrorModal;
